import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import BlogDetails from "./Pages/BlogDetails";
import Home from "./Pages/Home";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/blogs/:blogId"
          element={<BlogDetails />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
